import React, { memo } from 'react';
import cn from 'classnames';

import { WpTooltip, WpTooltipContent, WpTooltipTrigger } from 'Wpds/components/tooltip';

import './RoundCheckbox.scss';

type Props = {
  checked: boolean;
  onToggle?: (event: React.MouseEvent<HTMLInputElement>) => void;
  className?: string;
};

function RoundCheckbox({ checked, onToggle, className }: Props) {
  const content = (
    <div
      className={cn(
        `round-checkbox ${className}`,
        { 'round-checkbox--is-selected': checked },
        { 'round-checkbox--not-read-only': onToggle }
      )}
      onClick={onToggle}
    >
      <div className="round-checkbox-checkmark" />
    </div>
  );

  if (!checked && onToggle) {
    return (
      <WpTooltip>
        <WpTooltipTrigger>{content}</WpTooltipTrigger>
        <WpTooltipContent>Mark as complete</WpTooltipContent>
      </WpTooltip>
    );
  }

  return <>{content}</>;
}

export default memo(RoundCheckbox);
